import React, { useState } from 'react';
import { style } from 'typestyle';
import CheckIcon from 'mdi-react/CheckCircleIcon';
import * as styles from './cards.styles';
import type Office from '../models/office';
import { MainAxisAlignment, CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import Row from '../../../core/components/row/row.component';

interface Props {
  readonly office: Office;
  readonly checked: boolean;
}

const OfficeListCard = ({ office, checked }: Props): React.JSX.Element => {
  const [isChecked, setIsChecked] = useState(checked);

  const onClick = (): void => {
    setIsChecked(!isChecked);
  };

  return (
    <div className={style(styles.infoCard(true))} key={office.name} onClick={onClick} role="presentation">
      <Row mainAxisAlignment={MainAxisAlignment.SpaceBetween} crossAxisAlignment={CrossAxisAlignment.Center}>
        <span className={style(styles.cardHeader())}>{office.name}</span>
        <CheckIcon className={style(styles.checkIcon(isChecked))} />
      </Row>
    </div>
  );
};

export default OfficeListCard;
